import { Spin } from 'antd';
import styles from './Loading.module.css';
const Loading = ({saving})=>{
    return <div className={styles.Loading}> 
    <Spin />
    {saving ? <div>درحال ذخیره سازی ...</div> :<div>درحال دریافت اطلاعات ...</div> }
    
    </div>
}
export default Loading;